import gql from 'graphql-tag';
import { USER_FRAGMENT } from './user.fragment';
import { PHOTO_FRAGMENT } from './photo';

// export const USERS = gql`
//   ${USER_FRAGMENT}
//   query Users($take: Int, $offset: Int) {
//     users(take: $take, offset: $offset) {
//       ...UserFragment
//     }
//   }
// `;

export const USER = gql`
  ${USER_FRAGMENT}
  query User($id: ID!) {
    user(id: $id) {
      ...UserFragment
    }
  }
`;

export const CURRENT_USER = gql`
  ${PHOTO_FRAGMENT}
  query CurrentUser {
    me {
      id
      firstName
      lastName
      email
      avatar {
        ...PhotoFragment
      }
      aliases {
        auth0
        createdAt
      }
      vendorUsers {
        id
        vendor {
          id
          name
          handle
        }
      }
      eventUsers {
        id
        status
        eventV0918 {
          id
          eventId
          website
        }
      }
    }
  }
`;
